/* ===========================================================================
   WWC CRO-concept - één bron voor "wat heeft de klant nu gekozen"

   WAAROM DIT BESTAAT
   Maat, materiaal en variant werden op drie plekken los van elkaar uit de DOM
   gevist: de maatkiezer (wwc-product.js), de materiaalkaarten
   (wwc-woodtype-bubbles) en de galerij. Elke module had zijn eigen selectors en
   zijn eigen aannames over de optienaam. Bij elke opmaakwijziging brak er een.

   Dit bestand houdt die staat op één plek bij en stuurt een event uit zodra er
   iets wijzigt. Nieuwe modules - de bundelmotor voorop - haken daarop aan in
   plaats van zelf de DOM af te struinen.

   GEBRUIK
     var keuze = window.WWC.getSelection();
     // { size, sizeNumber, material, materialHandle, variantId, productId, available }

     document.addEventListener('wwc:selection', function (e) {
       e.detail // dezelfde vorm
     });

   ONTWERPKEUZES
   - Leest, schrijft niet. Deze module verandert nooit de selectie; dat blijft
     bij de variantkiezer van het thema. Zou hij ook schrijven, dan krijg je
     twee partijen die de waarheid bepalen en dat is precies wat we oplossen.
   - Stuurt alleen uit bij een ECHTE wijziging. Het thema vuurt meerdere
     change-events per klik; zonder vergelijking krijgt de bundelmotor drie
     keer hetzelfde en herberekent hij drie keer.
   - Faalt stil. Geen maatkiezer op de pagina betekent size: null, geen fout.
   =========================================================================== */

(function () {
  /* Versiemarkering: maakt zichtbaar WELKE build er draait wanneer gedrag en
     bronbestand uit elkaar lijken te lopen. */
  window.__wwcSelBuild = (window.__wwcSelBuild || 0) + 1;
  window.__wwcSelVersion = 'herlees-v3';

  if (window.WWC && window.WWC.getSelection) return;

  window.WWC = window.WWC || {};

  /* De optienaam verschilt per taal. Zelfde lijst als in wwc-product.js en
     wwc-woodtype-bubbles - houd ze gelijk. */
  var SIZE_NAMES = ['Afmeting', 'Size', 'Größe', 'Grösse', 'Taille'];

  var huidig = null;

  function getal(tekst) {
    var m = String(tekst || '').match(/[\d.,]+/);
    if (!m) return null;
    var n = parseFloat(m[0].replace(',', '.'));
    return isNaN(n) ? null : n;
  }

  function lees() {
    var maatInput = null;
    for (var i = 0; i < SIZE_NAMES.length && !maatInput; i++) {
      maatInput = document.querySelector('input[name="' + SIZE_NAMES[i] + '"]:checked');
    }

    /* Het huidige materiaal is het product dat je bekijkt: elke houtsoort is
       een eigen product. De kaart met is-current draagt het label. */
    var matKaart = document.querySelector('.wwc-material-option.is-current');
    var matNaam = null;
    if (matKaart) {
      var naamEl = matKaart.querySelector('.wwc-material-option__name');
      /* Alleen de naam, niet de prijs die in dezelfde knoop staat. */
      var prijsEl = naamEl && naamEl.querySelector('.wwc-material-option__price');
      var ruw = naamEl ? naamEl.textContent : '';
      if (prijsEl) ruw = ruw.replace(prijsEl.textContent, '');
      matNaam = ruw.replace(/\s+/g, ' ').trim() || null;
    }

    var vId = null;
    var vInput = document.querySelector('[name="id"]');
    if (vInput && vInput.value) vId = String(vInput.value);

    var atc = document.querySelector('[name="add"]');

    return {
      size: maatInput ? maatInput.value : null,
      sizeNumber: maatInput ? getal(maatInput.value) : null,
      material: matNaam,
      materialHandle: matKaart ? (matKaart.getAttribute('data-mat-base') || '').split('/').pop() : null,
      variantId: vId,
      productId: (window.meta && meta.product && meta.product.id) ? String(meta.product.id) : null,
      available: atc ? !atc.disabled : null
    };
  }

  function gelijk(a, b) {
    if (!a || !b) return false;
    return a.size === b.size &&
           a.material === b.material &&
           a.variantId === b.variantId &&
           a.available === b.available;
  }

  function ververs(reden) {
    var nieuw = lees();
    if (gelijk(huidig, nieuw)) return;
    huidig = nieuw;
    document.dispatchEvent(new CustomEvent('wwc:selection', {
      detail: Object.assign({ reason: reden || 'change' }, nieuw)
    }));
  }

  window.WWC.getSelection = function () {
    if (!huidig) huidig = lees();
    return Object.assign({}, huidig);
  };

  /* Het thema wisselt varianten via change op de radio's en werkt daarna
     [name="id"] bij. Eén frame wachten, anders lezen we de vorige variant. */
  /* NIET vertrouwen op het change-event alleen.

     Motion hertekent bij een variantwissel de hele productsectie. De radio waar
     het event op afging bestaat daarna niet meer, en het vervangen stuk HTML
     voert zijn eigen scripts niet opnieuw uit. Een change-haak - ook in de
     capture-fase - bleek daardoor onbetrouwbaar: de DOM klopte wel, maar wij
     hoorden het niet.

     Daarom kijken we naar het RESULTAAT in plaats van naar het signaal: na elke
     klik en elke change een paar keer opnieuw lezen. ververs() stopt zelf zodra
     er niets gewijzigd is, dus dit kost bijna niets. */
  function herleesStraks(reden) {
    window.requestAnimationFrame(function () { ververs(reden); });
    window.setTimeout(function () { ververs(reden); }, 120);
    window.setTimeout(function () { ververs(reden); }, 400);
  }

  document.addEventListener('change', function () { herleesStraks('variant'); }, true);
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* Alleen bij iets dat een keuze kán zijn - niet bij elke klik op de pagina. */
    if (!t.closest('.variant-input, .variant-input-wrap, .wwc-material-option, [data-variant-input]')) return;
    herleesStraks('klik');
  }, true);

  /* De quick view plakt een productsectie in een bestaande pagina; daar valt
     geen change-event op te wachten. */
  document.addEventListener('quickview:loaded', function () { ververs('quickview'); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { ververs('init'); });
  } else {
    ververs('init');
  }
})();
